import { render, staticRenderFns } from "./DeviceSetup.vue?vue&type=template&id=52d32e74&"
import script from "./DeviceSetup.vue?vue&type=script&lang=js&"
export * from "./DeviceSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports